<template>
  <div class="victoria-brand" :class="{ 'victoria-brand--compact': compact }">
    <img
      class="victoria-brand__logo"
      :src="$brand.logo"
      :alt="$brand.name + ' logo'"
    >
    <!-- <div v-if="showName" class="victoria-brand__name">{{ $brand.name }}</div> -->
  </div>
</template>

<script>
export default {
  name: 'VictoriaBrand',
  props: {
    compact: {
      type: Boolean,
      default: false
    },
    showName: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.victoria-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--victoria-text);
  text-align: center;
}

.victoria-brand__logo {
  width: 5.65rem;
  max-width: 228px;
  aspect-ratio: 1;
  object-fit: contain;
  mix-blend-mode: screen;
  filter: drop-shadow(0 0.18rem 0.5rem rgba(231, 160, 174, 0.18));
}

.victoria-brand__name {
  margin-top: -0.28rem;
  font-family: var(--victoria-font-ui);
  font-size: 0.38rem;
  line-height: 1.3;
  letter-spacing: 0.13rem;
  text-transform: uppercase;
  text-shadow: 0 0 0.4rem rgba(231, 160, 174, 0.28);
}

.victoria-brand__ornament {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.8rem;
  margin-top: 0.18rem;
}

.victoria-brand__ornament span {
  width: 1rem;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--victoria-primary));
}

.victoria-brand__ornament span:last-child {
  background: linear-gradient(90deg, var(--victoria-primary), transparent);
}

.victoria-brand__ornament i {
  width: 0.13rem;
  height: 0.13rem;
  margin: 0 0.12rem;
  border-radius: 50%;
  background: var(--victoria-light-rose);
  box-shadow: 0 0 0.24rem rgba(255, 209, 217, 0.55);
}

.victoria-brand--compact .victoria-brand__logo {
  width: 4.05rem;
  max-width:44.933vw;
}

.victoria-brand--compact .victoria-brand__name {
  font-size: 0.3rem;
  letter-spacing: 0.1rem;
}
</style>
